export const GET_CLIENT_VISIT_DETAIL = 'GET_CLIENT_VISIT_DETAIL';
export const GET_WORKSHOP_VISIT_DETAIL = 'GET_WORKSHOP_VISIT_DETAIL';
